import style from '../../styles/expenses.salary.statements.table.module.css'


export const Amount = ({props}) => {
    const {cashAmount, nonCashWithVAT, nonCashWithoutVAT} = props;
    return (
        <div className={style.amount__tooltip__text}>
            {cashAmount > 0 && <div>{cashAmount} € - наличными</div>}
            {nonCashWithoutVAT > 0 && <div>{nonCashWithoutVAT} € - б/н</div>}
            {nonCashWithVAT > 0 && <div>{nonCashWithVAT} € - б/н с НДС</div>}
        </div>
    )
}